module.exports = __webpack_public_path__ + "static/media/inside_view_front.381c2f17.jpg";